import { MessageOutlineIcon } from './MessageOutlineIcon';

/**
 * author: Google
 * id 2AE3707D-5DE3-41E6-968B-A56D3D9ADD40
 * name message-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-outline.svg
 * tags
 */
export const ChatBubbleOutlineIcon = MessageOutlineIcon;
export default ChatBubbleOutlineIcon